module.exports = __webpack_public_path__ + "static/media/Moda.13906b31.webp";